module.exports = __webpack_public_path__ + "img/01.aafc623a.jpeg";